import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { FaqModalComponent } from './faq-modal/faq-modal.component';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Module } from '../../models/common';
import { FAQ } from 'src/app/models/um/organization';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FaqorderComponent } from './faqorder/faqorder.component';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  StatusList: any[] = [];
  tempoperation;
  rowData;
  formData;
  advanceSearch;
  selectedRow;
  faqs: FAQ[] = [];
  faqForm: UntypedFormGroup;
  modules: any;
  proglist: any[] = []
  modulelist: Module[] = [];
  faq: FAQ;
  ist: string = '';
  eap: string = '';
  grants: string = '';
  isSettings: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public route: ActivatedRoute,
    private criteriaService: CommonCriteriaService,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
  ) {

  }
  ngOnInit() {

    this.StatusList.push({ label: "All", value: "-1" });
    this.StatusList.push({ label: "Active", value: "1" });
    this.StatusList.push({ label: "Inactive", value: "0" });

    this.collapesedOrNot = false;
    this.faqForm = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      FAQ: new UntypedFormControl(""),
      STATUS: new UntypedFormControl("-1"),
      // Program: new UntypedFormControl(""),
      Module: new UntypedFormControl("-1"),
      IS_FOR_IST: new UntypedFormControl(false),
      IS_FOR_EAP: new UntypedFormControl(false),
      IS_FOR_GRANTS: new UntypedFormControl(false)
    });

    this.columnDefs =
      [{ "headerName": "FAQ’s ", "field": "QUESTION" },
      { "field": "MODULES", "headerName": "Applicable programs " },
      { "field": "tARGETuserstring", "headerName": "Target User" },
      { "field": "MappedAppTypesNames", "headerName": "Application Type" },
      { "field": "STATUS", "headerName": "Status" }];



    this.advanceSearch = {
      "fields": [, { "label": "FAQ", "field": "faq", "type": "text" },
        { "label": "Status", "field": "Status", "type": "dropdown" },
        {
          "label": "Program",
          "field": "Module",
          "type": "dropdown",
          "options": this.modulelist
        }]
    };


    this.tempoperation = [];
    if (this.commonService.getScreenPermission("609", "E")) {
      this.isSettings = true;
      this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if (this.commonService.getScreenPermission("609", "D")) {
      this.isSettings = true;
      this.tempoperation.push({
        "name": "Delete",
        "id": "delete"
      });
    }

    if (this.commonService.getScreenPermission("609", "N")) {
      this.tempoperation.push({
        "name": "Add Frequently Asked Questions",
        "id": "add"
      });
    }

    this.operations = this.tempoperation.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    var formData = this.faqForm.value;
    this.setSearchSummary(formData);

    //this.setSummary("");
    this.getModules();
  }

  setSearchSummary(formData) {
    if (formData["STATUS"] == null || formData["STATUS"] == undefined) {
      formData["STATUS"] = "-1";
    }
    this.summaryService.getAdvFAQ(formData).subscribe(summary => {
      this.rowData = summary
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }


  Reorder() {
    let modalRefAdd = this.modalService.open(FaqorderComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    let reOrderList = this.rowData.filter(x => x.RECORD_STATE == 1);
    modalRefAdd.componentInstance.Content = {

      heading: 'Reorder',
      content: { Data: reOrderList },
    }
    modalRefAdd.result.then(result => {
      var formData = this.faqForm.value;
      this.setSearchSummary(formData);

    })
  }

  getModules() {

    this.summaryService.getModuleByOrgId('api/common/getmodulesbyid').subscribe((result) => {
      this.modules = result;
      let len = this.modules.length;
      for (let i = 0; i < len; i++) {
        switch (this.modules[i].CODE) {
          case "IST":
            this.ist = "1";
            this.proglist.push({ label: this.modules[i].NAME, value: "IST" });
            break;
          case "EAP":
            this.eap = "2";
            this.proglist.push({ label: this.modules[i].NAME, value: "EAP" });
            break;
          case "GRA":
            this.grants = "3";
            this.proglist.push({ label: this.modules[i].NAME, value: "GRANTS" });
            break;
        }
      }
      this.proglist = [{ label: "All", value: "-1", checked: true }].concat(this.proglist);
    });
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    const ModelRef = this.modalService.open(FaqModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    ModelRef.componentInstance.Content = {
      heading: 'View',
      content: { id: this.selectedRow['ID'] }
    }
  }

  edit(RcordData: any) {
    const modalRef = this['self'].modalService.open(FaqModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: RcordData['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].setSearchSummary(this['self'].faqForm.value);
    })
  }

  add() {
    const modalRef = this['self'].modalService.open(FaqModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: null }
    }
    modalRef.result.then(result => {
      this['self'].setSearchSummary(this['self'].faqForm.value);
    })
  }

  delete(RcordData: any) {

    let id = RcordData['ID'];
    let name = RcordData['QUESTION'];
    let message = "";
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, { backdrop: false });
    modalRef.componentInstance.Content = {
      heading: '', custommessage: 'Are you sure you want to delete the FAQ ' + "'" + name + "'" + ' ?',
      ProceedButtonName: "Delete", TerminateButtonName: "Cancel"
    }
    modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.deleteFAQ(id).subscribe(result => {
          if (result.Status === 0) {
            this['self'].commonService.SuccessBanner(result.Message);


            this['self'].setSearchSummary(this['self'].faqForm.value);
          }
          else {
            this['self'].commonService.ErrorBanner(result.Message);
          }
        });
      }

    })

  }


  setSummary(filter: string) {
    let strfilter = "-1";
    if (filter !== "")
      strfilter = filter;
    this.summaryService.getFAQ(strfilter).subscribe(summary => {
      this.rowData = summary
    });
  }

  setSearch() {

    this.SearchClear();
    this.summaryService.getAdvFAQ(this.faqForm.value).subscribe(summary => {
      this.rowData = summary
    });


  }
  //// Advace search Functions
  SearchClear() {

    this.faqForm = new UntypedFormGroup({
      FAQ: new UntypedFormControl(""),
      STATUS: new UntypedFormControl("-1"),
      Module: new UntypedFormControl("-1"),
    });
  }

  AdvanceSearch() {
    this.setSearchSummary(this.faqForm.value);
  }
}
